import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=1f7d8a90&"
import script from "./Billing.vue?vue&type=script&lang=js&"
export * from "./Billing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7d8a90')) {
      api.createRecord('1f7d8a90', component.options)
    } else {
      api.reload('1f7d8a90', component.options)
    }
    module.hot.accept("./Billing.vue?vue&type=template&id=1f7d8a90&", function () {
      api.rerender('1f7d8a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/billing/Billing.vue"
export default component.exports